/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 16:12:00
 */

import DiskConfig from '../diskConfig';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import DiskConfigApi, { DiskConfigDOI } from '../api/diskConfigApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumDiskBank from 'src/enums/enumDiskBank';
import EnumCloud from 'src/enums/EnumCloud';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import Input from 'src/types/iview/Input';
import alertOperateDiskModal from '../operateDiskModal';
import alertOperateDiskPushModal from '../operateDiskPushModal';
import EnumOperates from 'src/enums/enumOperates';
import alertOperateModal from 'src/components/operateModal/operateModal';
import DatePicker from 'src/types/iview/DatePicker';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import EnumStationType from 'src/enums/enumStationType';
import DiskConfigDOI from '../api/diskConfigApi';
const DEFINITION = [{ id: 0, name: '240p' }, { id: 2, name: '480p' }, { id: 3, name: '720p' }, { id: 4, name: '1080p' }];
const MONITOR_IMG = {
    1: require('../../../../assets/images/监控01.png'),
    0: require('../../../../assets/images/监控02.png'),
}
export default class DiskConfigService extends ListPageService {
    ctx: DiskConfig;

    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor(ctx: DiskConfig) {
        super();
        this.ctx = ctx;
    }

    formData: DiskConfigDOI.DeleteParamsI = {
        type:null,  // 1萤石云  2乐橙云  3 本地监控
        dvr_id:null,
        nvr_user_id: null,
        deviceserial: "",
    };

    formData1: DiskConfigDOI.Defence = {
        nvr_user_id: null,
        type:null,  // 1萤石云  2乐橙云  3 本地监控
        deviceserial: ""
     };

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '站点名称',
                field: 'device_name',
                minWidth: 190,
            },
            {
                headerName: '云端类型',
                field: 'type',
                minWidth: 80,
                cellRenderer(params) {
                    let data: DiskConfigDOI.RowDataI = params.data;
                    return EnumCloud.findId(data.type).getName();
                },
            },
            {
                headerName: '硬盘机名称',
                field: 'name',
                minWidth: 140,
            },
            {
                headerName: '通道总数',
                field: 'channel_total_count',
                minWidth: 90,
            },
            {
                headerName: '云端账户',
                field: 'nvr_user_name',
                minWidth: 140,
            },
            {
                headerName: '设备序列号',
                field: 'deviceserial',
                minWidth: 180,
            },
            // {
            //     headerName: '实时监控',
            //     field: 'create_time',
            //     minWidth: 100,
            //     cellRendererFramework: CellRenderTsx,
            //     cellRendererFrameworkOpt: {
            //         cellRender(h, params) {
            //             let data: DiskConfigDOI.RowDataI = params.data;
            //             return <img src={MONITOR_IMG[data.status]}></img>
            //         }
            //     }
            // },
            {
                headerName: '账号',
                field: 'username',
                minWidth: 140,
            },
            {
                headerName: '路径',
                field: 'dvr_url',
                minWidth: 140,
            },
            {
                headerName: '监控品牌',
                field: 'brand_type',
                minWidth: 140,
                cellRenderer(params) {
                    let data: DiskConfigDOI.RowDataI = params.data;
                    return EnumDiskBank.findId(data.brand_type).getName();
                },
            },
            {
                headerName: '时间',
                field: 'create_time',
                minWidth: 180,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 380,
                maxWidth: 380,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '开启推流',
                        click: t.pushStream.bind(t),
                    },
                    {
                        text: '关闭推流',
                        disabled(params) {
                            let data: DiskConfigDOI.RowDataI = params.data;
                            return data.type !==3;
                        },
                        click: t.closeStream.bind(t),
                    },
                    {
                        text: '开启回放',
                        disabled(params) {
                            let data: DiskConfigDOI.RowDataI = params.data;
                            return data.type !==3;
                        },
                        click: t.pushBackStream.bind(t),
                    },
                    {
                        text: '修改',
                        disabled(params) {
                            let data: DiskConfigDOI.RowDataI = params.data;
                            return data.type !==3;
                        },
                        async click(params) {
                            let data: DiskConfigDOI.RowDataI = params.data;
                            let res = await alertOperateDiskModal(EnumOperates.Update.getName(), JSON.parse(JSON.stringify(data)));
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: DiskConfigDOI.RowDataI = params.data;
                            t.formData.type = data.type;
                            t.formData.dvr_id = data.id;
                            t.formData.nvr_user_id = data.nvr_user_id;
                            t.formData.deviceserial = data.deviceserial;
                            await t.delete();
                        },
                    },
                    {
                        text: '开启布防',
                        disabled(params) {
                            let data: DiskConfigDOI.RowDataI = params.data;
                            return data.type !==1;
                        },
                        click: t.Defence.bind(t),
                    },
                ],
            },
        ];
    }

    async pushStream(params) {
        let t = this;
        let data: DiskConfigDOI.RowDataI = params.data;
        let chanels = await t.searchChanels(data.id, 1);
        if(data.type == 3){
            let res = await alertOperateModal({
                title: '开启推流',
                api: DiskConfigApi.push,
                defaultParams: { dvr_id: data.id },
                inputItems: [
                    {
                        component: CommonSelect,
                        label: '通道',
                        field: 'channel_nums',
                        dataType: 'array',
                        required: true,
                        props: {
                            value: null,
                            dataSource: chanels,
                            multiple: true,
                            placeholder: '请选择',
                            clearable: false,
                        },
                    },
                    {
                        component: CommonSelect,
                        label: '清晰度',
                        field: 'stream_type',
                        dataType: 'number',
                        required: true,
                        props: {
                            value: null,
                            dataSource: DEFINITION,
                            placeholder: '请选择',
                            clearable: false,
                            required: true,
                        },
                    },
                ],
            });
            if (res) {
                t.searchTable();
            }
        }else{
            let params = {
                ...data,
                ...{"chanels": chanels},
            };
            let res = await alertOperateDiskPushModal(JSON.parse(JSON.stringify(params)), data.type);
            if (res) {
                t.searchTable();
            }
        }
    }

    async closeStream(params) {
        let t = this;
        let data: DiskConfigDOI.RowDataI = params.data;
        let chanels = await t.searchChanels(data.id, 0);
        let res = await alertOperateModal({
            title: '结束推流',
            api: DiskConfigApi.close,
            defaultParams: { dvr_id: data.id },
            inputItems: [
                {
                    component: CommonSelect,
                    label: '通道',
                    field: 'channel_nums',
                    dataType: 'array',
                    required: true,
                    props: {
                        value: null,
                        dataSource: chanels,
                        multiple: true,
                        placeholder: '请选择',
                        clearable: false,
                    },
                },
            ],
        });
        if (res) {
            t.searchTable();
        }
    }

    async pushBackStream(params) {
        let t = this;
        let data: DiskConfigDOI.RowDataI = params.data;
        let chanels = await t.searchChanels(data.id, 1);
        let res = await alertOperateModal({
            title: '开启回放',
            api: DiskConfigApi.pushBack,
            defaultParams: { dvr_id: data.id },
            inputItems: [
                {
                    component: CommonSelect,
                    label: '通道',
                    field: 'channel_nums',
                    dataType: 'array',
                    required: true,
                    props: {
                        value: null,
                        dataSource: chanels,
                        multiple: true,
                        placeholder: '请选择',
                        clearable: false,
                    },
                },
                {
                    component: CommonSelect,
                    label: '清晰度',
                    field: 'stream_type',
                    dataType: 'number',
                    required: true,
                    props: {
                        value: null,
                        dataSource: DEFINITION,
                        placeholder: '请选择',
                        clearable: false,
                        required: true,
                    },
                },
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    realField: ['start_time', 'end_time'],
                    dataType: 'array',
                    timeType: 'number',
                    props: { value: [], type: 'datetimerange',  placeholder: '请选择时间', clearable: false },
                },
            ],
        });
        if (res) {
            t.searchTable();
        }
    }

    async searchChanels(id: number, type: number): Promise<{ id: number; name: string }[]> {
        let { code, data } = await DiskConfigApi.searchChanel({ dvr_id: id });
        if (code === 0) {
            return data.filter(i => i.status === type).map(i => ({ id: i.channel_num, name: i.channel_num + '' }));
        } else {
            return [];
        }
    }

    async Defence(params){
        this.formData1.deviceserial = params.data.deviceserial;
        this.formData1.nvr_user_id = params.data.nvr_user_id;
        this.formData1.type = params.data.type;
        let { code } = await DiskConfigApi.getDefence(this.formData1);
        if (code === 0) {
            Toast.success('开启布防成功');
        }
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '站点：',
                field: 'device_id',
                labelWidth: 100,
                width: 300,
                props: { value: null, placeholder: '请选择', type: EnumEntity.Station.getId() },
            },
            {
                component: CommonSelect,
                label: '云端类型：',
                field: 'nvr_type',
                labelWidth: 100,
                width: 300,
                props: { value: null, dataSource: EnumCloud.getList() },
            },
            {
                component: Input,
                label: '硬盘机名称：',
                field: 'name',
                labelWidth: 100,
                width: 300,
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateDiskModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete() {
        let { code } = await DiskConfigApi.delete(this.formData);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<DiskConfigDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await DiskConfigApi.searchList({
            ...ctx.searchParams,
            type: this.type,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
